const getCluster = (state) => (id) => {
  if (!state.clusters) { return state.defaultCluster }
  return state.clusters[id]
}

const getDevice = (state) => (id) => {
  if (!state.devices) { return state.defaultDevice }
  return state.devices[id]
}

const getPlaylist = (state) => (id) => {
  if (!state.playlists) { return state.defaultPlaylist }
  return state.playlists[id]
}

const getMenu = (state) => (id) => {
  if (!state.menus) { return state.defaultMenu }
  return state.menus[id]
}

const getSpecialOffer = (state) => (id) => {
  if (!state.specialOffers) { return state.defaultMenu }
  return state.specialOffers[id]
}

/* const getItemNumForPlaylist = (state) => (id) => {
  let playlist = state.playlists[id]
  if (playlist.items) {
    return playlist.items.filter(x => x).length
  } else { return 'N/A' }
} */

const getDevicesForCluster = (state) => (id) => {
  let ret = {}
  for (let device in state.devices) {
    if (state.devices[device].clusterId === id) {
      ret[device] = state.devices[device]
    }
  }
  return ret
}

const getDeviceName = (state) => (id) => {
  let deviceName = ''
  for (let device in state.devices) {
    if (device === id) {
      deviceName = state.devices[device].name
      break
    }
  }
  return deviceName
}

const getDevicesCountForCluster = (state) => (id) => {
  let counter = 0
  for (let device in state.devices) {
    if (state.devices[device].clusterId === id) {
      counter++
    }
  }
  return counter
}

const getPlaylistNameForCluster = (state) => (id) => {
  let temp = state.clusters[id]
  if (temp && temp.mainPlaylistId.length > 0) {
    return state.playlists[temp.mainPlaylistId].name
  } else { return 'None' }
}

const getUnassignedDevices = (state) => {
  let ret = {}
  for (let device in state.devices) {
    if (state.devices[device].clusterId.length === 0) {
      ret[device] = state.devices[device]
    }
  }
  return ret
}

const getClustersForPlaylist = (state) => (id) => {
  let ret = {}
  for (let cluster in state.clusters) {
    if (state.clusters[cluster].mainPlaylistId === id) {
      ret[cluster] = state.clusters[cluster]
    }
  }
  return ret
}

const getClustersForMenu = (state) => (id) => {
  let ret = {}
  for (let cluster in state.clusters) {
    if (state.clusters[cluster].menuId === id) {
      ret[cluster] = state.clusters[cluster]
    }
  }
  return ret
}

const getClustersForSpecialOffer = (state) => (id) => {
  let ret = {}
  for (let cluster in state.clusters) {
    if (state.clusters[cluster].specialOffersMenuId === id) {
      ret[cluster] = state.clusters[cluster]
    }
  }
  return ret
}

export default {
  getCluster,
  getDevice,
  getPlaylist,
  getMenu,
  getSpecialOffer,
  getDevicesForCluster,
  getDevicesCountForCluster,
  getPlaylistNameForCluster,
  getUnassignedDevices,
  getClustersForPlaylist,
  getClustersForMenu,
  getClustersForSpecialOffer,
  getDeviceName
}



// WEBPACK FOOTER //
// ./src/store/getters.js